var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLendlease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LL_Main",
    "data-name": "LL Main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 217.5,
    y1: 53.84,
    x2: 31.39,
    y2: 144.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0eb1bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#31c28a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6add3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91f00a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 179.49,
    y1: 99.42,
    x2: 249.45,
    y2: 99.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ba0a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9d9d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.55,
    y1: 44.87,
    x2: 99.46,
    y2: 44.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ff00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.53,47a12.78,12.78,0,0,0-10.9,3.73l-35.08,36a7.58,7.58,0,0,1-10,.7l112,86.47a25.75,25.75,0,0,0,36.13-4.65c.28-.36.55-.72.8-1.09l65.67-95a7.59,7.59,0,0,1,7.27-3.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.74,114.82,179.49,129l38.59-55.84a7.58,7.58,0,0,1,13.19,1.3L244.46,105a9.78,9.78,0,0,0,5,5.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.8,8A9.88,9.88,0,0,0,10.08.73L99.46,52.55,59.53,47a12.78,12.78,0,0,0-10.9,3.73l-35.08,36A7.57,7.57,0,0,1,.65,80.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.39,90.13v12.49H81.55V91.21a2.57,2.57,0,0,0-2.84-2.87,6.3,6.3,0,0,0-2.17.41v13.87H71.69v-17A20.47,20.47,0,0,1,79.16,84C84.14,84,86.39,86.5,86.39,90.13Zm72.45,1.52-2.63-.89c-1.07-.38-1.45-.83-1.45-1.35,0-.73.73-1.25,2.07-1.25a9.59,9.59,0,0,1,4.39,1.25l2.12-3.77A14.28,14.28,0,0,0,156.77,84c-4,0-7.06,2.35-7.06,5.74s2.38,4.78,4.57,5.5l2.31.76c1.21.42,1.8.76,1.8,1.52s-.62,1.28-2.25,1.28a9.59,9.59,0,0,1-4.73-1.41l-2.08,3.84a13.82,13.82,0,0,0,6.88,1.72c4,0,7.26-2.28,7.26-5.91C163.47,94,161.57,92.59,158.84,91.65ZM51.53,98.78c-1,0-1.38-.49-1.38-1.63V77.68H45.31V98.54c0,3,1.86,4.42,4.7,4.42a10.89,10.89,0,0,0,3.7-.62l-.52-3.84A6.58,6.58,0,0,1,51.53,98.78Zm47.66-21.1H104v23.69a18.6,18.6,0,0,1-7.4,1.59c-5,0-7.44-3-7.44-6.64v-6c0-3.63,2.42-6.26,6.61-6.26a11.23,11.23,0,0,1,3.39.53Zm0,10.9a7.5,7.5,0,0,0-2.32-.42A2.74,2.74,0,0,0,94,91.24v4.39a2.87,2.87,0,0,0,3.18,3.15,5.69,5.69,0,0,0,2-.35ZM69.07,91.34v3.74H59.45v.31a3.12,3.12,0,0,0,3.36,3.39,9,9,0,0,0,4.53-1.28l1.35,3.84A12.49,12.49,0,0,1,62.25,103c-3.91,0-7.64-2.11-7.64-7.47v-3.8c0-4.7,2.84-7.68,7.33-7.68C66.64,84,69.07,87.16,69.07,91.34Zm-4.68-.2c0-1.73-.79-2.94-2.41-2.94s-2.49,1.21-2.49,2.94v.31h4.9Zm49,7.64c-1,0-1.38-.49-1.38-1.63V77.68h-4.84V98.54c0,3,1.86,4.42,4.7,4.42a10.89,10.89,0,0,0,3.7-.62l-.52-3.84A6.58,6.58,0,0,1,113.4,98.78Zm34-9v11.58A19.51,19.51,0,0,1,140.1,103c-4.74,0-7.34-2.28-7.34-6,0-3.15,2.32-5.5,6.44-5.5h3.35v-.76c0-1.66-1.24-2.32-3-2.32a12.44,12.44,0,0,0-5.33,1.49l-.48-4.36A16.09,16.09,0,0,1,140.65,84C143.49,84,147.39,85.26,147.39,89.79Zm-4.84,5.29H140c-1.48,0-2.35.79-2.35,1.87,0,1.28,1.14,2,2.73,2a7.43,7.43,0,0,0,2.18-.34Zm-11.62-3.74v3.74h-9.61v.31a3.11,3.11,0,0,0,3.35,3.39,9,9,0,0,0,4.53-1.28l1.35,3.84a12.42,12.42,0,0,1-6.43,1.62c-3.91,0-7.64-2.11-7.64-7.47v-3.8c0-4.7,2.83-7.68,7.33-7.68C128.51,84,130.93,87.16,130.93,91.34Zm-4.67-.2c0-1.73-.79-2.94-2.42-2.94s-2.49,1.21-2.49,2.94v.31h4.91Zm53.54.2v3.74h-9.62v.31a3.12,3.12,0,0,0,3.36,3.39,9,9,0,0,0,4.53-1.28l1.35,3.84A12.47,12.47,0,0,1,173,103c-3.91,0-7.64-2.11-7.64-7.47v-3.8c0-4.7,2.84-7.68,7.33-7.68C177.38,84,179.8,87.16,179.8,91.34Zm-4.67-.2c0-1.73-.8-2.94-2.42-2.94s-2.49,1.21-2.49,2.94v.31h4.91Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLendlease);
export default __webpack_public_path__ + "static/media/Logo_Lendlease.f411d8308f6bb8e486b7c5af3088a0ba.svg";
export { ForwardRef as ReactComponent };